import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Col, Container, Form, Modal, Row, Tab, Table, Tabs } from 'react-bootstrap';
import "../../../../node_modules/react-datepicker/dist/react-datepicker.css";
import $ from 'jquery';
import * as Common from '../../Common';
import Dialog from '../../Dialog';
import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRupeeSign, faEye, faEdit, faCloudUploadAlt, faCloudDownloadAlt } from '@fortawesome/free-solid-svg-icons';
import Ad1CoverRate from './Ad1CoverRate';
import AsyncSelect from 'react-select/async';
import * as Picklist from "../../Picklist";
import { faShareSquare } from '@fortawesome/free-regular-svg-icons';
import Ad1AdditionalDetails from './Ad1AdditionalDetails';
import Loginheader from '../../Loginheader';
import Menu from '../../Menu';
import Ad1FinalDocUpload from './Ad1FinalDocUpload';
import Ad1FinalDocDownload from './Ad1FinalDocDownload';
import Ad1RequestHeader from './Ad1RequestHeader';
import Ad1ActivityLog from './Ad1ActivityLog';



function Ad1() {
    const navigate = useNavigate();
    const [userRight, setUserRight] = useState([]);
    const [coverRight, setCoverRight] = useState([]);
    const [addiDetailRight, setAddiDetailRight] = useState([]);
    const [finalDocUploadRight, setFinalDocUploadRight] = useState([]);
    const [finalDocDownRight, setFinalDocDownRight] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [entityType, setEntityType] = useState("A");
    const [reqBranchCode, setReqBranchCode] = useState("0");
    const [reqBranchName, setReqBranchName] = useState("0");
    const [ddReqBranchOptions, setDdReqBranchOptions] = useState([]);
    const [reqReference, setReqReference] = useState("S");
    const [reqAgent, setReqAgent] = useState("0");
    const [ddReqAgentOptions, setDdReqAgentOptions] = useState([]);
    const [reqAgentLocation, setReqAgentLocation] = useState("0");
    const [ddReqAgentLocationOptions, setDdReqAgentLocationOptions] = useState([]);
    const [reqCommission, setreqCommission] = useState();
    const [reqGst, setreqGst] = useState();
    const [reqTcs, setreqTcs] = useState();
    const [reqNostro, setreqNostro] = useState(0);
    const [reqRoundoff, setreqRoundoff] = useState(0);
    const [reqRemitterName, setReqRemitterName] = useState("");
    const [reqIsd, setReqIsd] = useState("0");
    const [ibr, setIbr] = useState("0");
    const [ddReqIsdOptions, setDdReqIsdOptions] = useState([]);
    const [reqSellRate, setReqSellRate] = useState("");
    const [reqPan, setReqPan] = useState("");
    const [reqNameOnPan, setReqNameOnPan] = useState("");
    const [reqAdhar, setReqAdhar] = useState("");
    const [rdBank, setRdBank] = useState("Y");
    const [reqBankCode, setreqBankCode] = useState(0);
    const [reqIssuer, setReqIssuer] = useState("0");
    const [ddReqIssuer, setDdReqIssuer] = useState([]);
    const [reqMobile, setReqMobile] = useState("");
    const [panTCS, setPanTCS] = useState([]);
    const [showConfirmBox, setShowConfirmBox] = useState(false);
    const [reqValDate, setReqValDate] = useState(new Date());
    const [reqEmail, setReqEmail] = useState("");
    const [reqNostroType, setReqNostroType] = useState("0");
    const [reqRemark, setReqRemark] = useState("");
    const [reqRemitterDob, setReqRemitterDob] = useState(new Date());
    const [reqBenCountry, setReqBenCountry] = useState("");
    const [reqProduct, setReqProduct] = useState("TT");
    const [reqProductType, setReqProductType] = useState(1);
    const [reqTaxableVal, setreqTaxableVal] = useState(0);
    const [pCharges, setPCharges] = useState(0);
    const [pTotal, setPTotal] = useState(0);
    const [disableOtherCharge, setDisableOtherCharge] = useState(true);
    const [scrMode, setScrMode] = useState("");
    const [pTotalAmount, setPTotalAmount] = useState(0);
    const [reqBankCharges, setreqBankCharges] = useState();
    const [reqFrom, setReqFrom] = useState(new Date());
    const [reqTo, setReqTo] = useState(new Date());
    const [tranListData, setTranListData] = useState([]);
    const [refreshCounter, setRefreshCounter] = useState(0);
    const [srchRef, setSrchRef] = useState("");
    const [showAddNewBtn, setShowAddNewBtn] = useState(true);
    const [showAddEditForm, setAddEditFormShow] = useState(false);
    const [srNo, setSrNo] = useState(0);
    const [viewObj, setViewObj] = useState();
    const [editObj, setEditObj] = useState();
    const [rightCoverrate, setRightCoverrate] = useState({});
    const [ddSrchBranOptions, setDdSrchBranOptions] = useState([]);
    const [srchBran, setSrchBran] = useState("0");
    const [srchBranSelect, setSrchBranSelect] = useState([]);
    const [reqTenure, setReqTenure] = useState("TOM");
    const [searchstatus, setSearchStatus] = useState("A");
    const [showFinalCoverForm, setShowFinalCoverForm] = useState(false);
    const [reqQuantity, setReqQuantity] = useState(0);
    const [showCvr, setShowCvr] = useState(false);
    const [showAdDtl, setShowAdDtl] = useState(false);
    const [showFinalDocUpload, setShowFinalDocUpload] = useState(false);
    const [reqRemitterType, setReqRemitterType] = useState("I");
    const [pickedCorporate, setPickedCorporate] = useState(null);
    const [pickedIndividual, setPickedIndividual] = useState(null);
    const [individual, setIndividual] = useState(0);
    const [individualId, setIndividualId] = useState(0);
    const [scrIndividual, setScrIndividual] = useState("");
    const [showIndividualForm, setShowIndividualForm] = useState(false);
    const [totalForex, setTotalForex] = useState(0);
    const [totalInr, setTotalInr] = useState(0);
    const [corpGroup, setCorpGroup] = useState(0);
    const [corpAccount, setCorpAccount] = useState(0);
    const [reqPurpose, setReqPurpose] = useState("0");
    const [ddReqPurposeOptions, setDdReqPurposeOptions] = useState([]);
    const [reqData, setReqData] = useState({});





    useEffect(() => {
        if (onceRun)
            return;
        Common.callApi(Common.apiRight, [sid, 'all', 'Ad1'], function (result) {
            let resp = JSON.parse(result);
            if (resp.add === "1") {
                setUserRight(resp);
                let storedEntityType = sessionStorage.entityType;
                setEntityType(storedEntityType);
                if (storedEntityType === "B") {
                    Common.callApi(Common.apiUser, [sid, 'branchallowed'], function (result) {
                        let resp = JSON.parse(result);
                        setDdReqBranchOptions(resp);
                        if (resp.length === 2) {
                            setReqBranchCode(resp[1].value);
                        }
                    });
                } else if (storedEntityType === "A") {
                    setReqReference("A");
                    Common.callApi(Common.apiEntity, [sid, 'agentbranchlink', sessionStorage.entityId], function (result) {
                        let resp = JSON.parse(result);
                        setDdReqBranchOptions(resp.oneBranch);
                        setDdReqAgentOptions(resp.oneAgent);
                        setReqBranchCode(resp.oneBranch[0].value);
                        setReqAgent(resp.oneAgent[0].value);
                    });
                } else {
                    navigate('/');
                }
                Common.callApi(Common.apiRight, [sid, 'all', 'COVERRATE'], function (result1) {
                    var tempCoverRate = JSON.parse(result1);
                    setRightCoverrate(tempCoverRate);
                    Common.callApi(Common.apiUser, [sid, 'branchallowedselect'], function (result) {
                        let resp2 = JSON.parse(result);
                        setDdSrchBranOptions(resp2);
                        if (resp2.length === 2) {
                            setSrchBranSelect(resp2[1]);
                            setSrchBran(resp2[1].value);
                            console.log(resp2);
                        }
                    });
                });
                Common.callApi(Common.apiIsd, [sid, 'ddlistjson'], function (result) {
                    setDdReqIsdOptions(JSON.parse(result));
                });
                Common.callApi(Common.apiIssuer, [sid, 'ddlistjson'], function (result) {
                    setDdReqIssuer(JSON.parse(result));
                    if (storedEntityType === "A") {
                        setreqBankCode("10");
                    }
                });
                Common.callApi(Common.apiPurpose, [sid, 'ddlistjsontt'], function (result) {
                    setDdReqPurposeOptions(JSON.parse(result));
                });
                // Common.callApi(Common.apiCountry, [sid, 'ddlistjson'], function (result) {
                //     setDdReqBranchOptions(JSON.parse(result));
                // });
            } else {
                Common.callApi(Common.apiRight, [sid, 'all', 'ENQUIRYLIST'], function (result) {
                    let resp = JSON.parse(result);
                    navigate(resp.view === "1" ? '/enquiry-status' : '/');
                });
            }

        });
        Common.callApi(Common.apiRight, [sid, 'all', 'AD1FINALDOCUPLOAD'], function (result) {
            let resp = JSON.parse(result);
            setFinalDocUploadRight(resp);
        });
        Common.callApi(Common.apiRight, [sid, 'all', 'AD1COVERRATE'], function (result) {
            let resp = JSON.parse(result);
            setCoverRight(resp);
        });
        Common.callApi(Common.apiRight, [sid, 'all', 'AD1ADDITIONALDETAILS'], function (result) {
            let resp = JSON.parse(result);
            setAddiDetailRight(resp);
        });
        Common.callApi(Common.apiRight, [sid, 'all', 'AD1FINALDOCDOWNLOAD'], function (result) {
            let resp = JSON.parse(result);
            setFinalDocDownRight(resp);
        });
        setOnceRun(true);
    }, [onceRun, sid, navigate, entityType]);

    useEffect(totalForexHanlder, [reqQuantity, reqSellRate])
    useEffect(totalInrHanlder, [reqQuantity, reqSellRate, reqTcs, reqGst, reqCommission, reqBankCharges, reqNostro, reqRoundoff])

    function onChangeBranch(id) {
        setReqBranchCode(id);
        onChangeRefrence("S")
    }

    function onChangeRefrence(id) {
        if (id === "S") {
            setReqAgent("0");
            setreqCommission(0);
        }
        setReqReference(id);
        if (id === "A") {
            Common.callApi(Common.apiEntity, [sid, 'ddlistjsonagentall', reqBranchCode], function (result) {
                setDdReqAgentOptions(JSON.parse(result));
            });
        } else {
            Common.callApi(Common.apiEntity, [sid, 'ddlistjsonagent', 0], function (result) {
                setDdReqAgentOptions(JSON.parse(result));
            });
        }
    }

    function onChangeAgent(id) {
        setReqAgent(id);
        setReqAgentLocation(0);
        Common.callApi(Common.apiEntity, [sid, 'ddlistjsonagentlocation', 'A', id], function (result) {
            setDdReqAgentLocationOptions(JSON.parse(result));
        });
    }

    function resetForm() {
        if (entityType === "B") {
            setReqReference("S");
            setReqAgent("0");
        }
        setreqCommission(0);
        setReqNameOnPan('')
        setPickedIndividual(null)
        setReqRemitterType('I');
        setreqBankCharges(0)
        setReqRemitterName("");
        setreqNostro(0)
        setReqIsd("0");
        setIbr("0");
        setReqQuantity("");
        setReqSellRate("");
        setReqNostroType("0");
        setReqPan("");
        setRdBank("Y");
        setReqMobile("");
        setReqBranchCode(0);
        setReqValDate(new Date());
        setReqEmail("");
        setReqRemark("");
        setreqTaxableVal("");
        setReqSellRate("");
        setPTotalAmount(0);
        setreqTcs(0);
        setPCharges(0);
        setreqRoundoff(0);
        setPTotal(0);
        setDisableOtherCharge(true);
        // setScrMode('A');
        setPTotalAmount(0);
        setreqBankCode("");
        setreqGst(0);
        setReqBranchName("");
        setCorpAccount(0);
        setCorpGroup(0);
        setPickedCorporate()
    }

    function saveData() {
        setShowConfirmBox(false);
        $('.loader').show();
        var isOk = true;
        var msg = [], i = 0;
        Common.validatePan(reqPan, setReqPan);
        if (entityType === "A") {
            if (reqBranchCode === "0" || (reqReference === "A" && reqAgent === "0")
                || reqRemitterName === ""
                || reqIsd === "0"
                || reqQuantity === "0"
                || (reqBankCode === "0" && rdBank === "Y")
                || reqNostroType === "0"
                || (reqAgent === "15" && reqAgentLocation === "0")
            ) {
                console.log("Issuer Bank", reqBankCode, rdBank);
                msg[i++] = Common.getMessage("MSG0006");
                msg[i++] = (reqBranchCode === "0" ? " Branch " : '');
                msg[i++] = (reqReference === "A" && reqAgent === "0" ? " Agent " : '');
                msg[i++] = (reqAgent === "15" && reqAgentLocation === "0" ? " Agent Location" : '');
                msg[i++] = (reqRemitterName === "" ? " Remitter Name " : '');
                msg[i++] = (reqIsd === "0" ? " Currency " : '');
                msg[i++] = (reqQuantity === "" ? " Quantity " : '');
                msg[i++] = (reqNostroType === "0" ? "Nostro Charges" : '');
                msg[i++] = ((reqBankCode === "0" && rdBank === "Y") ? " Issuer. " : '');
                isOk = false;
                $('.loader').hide();
                setMsgText(Common.buildMessageFromArray(msg));
                setMsgBox(true);
            }
        }
        if (entityType === "B") {
            if (reqBranchCode === "0" || (reqReference === "A" && reqAgent === "0")
                || reqIsd === "0"
                || reqQuantity === ""
                || (reqBankCode === "0" && rdBank === "Y")
                || (reqAgent === "15" && reqAgentLocation === "0")
            ) {
                msg[i++] = Common.getMessage("MSG0006");
                msg[i++] = (reqBranchCode === "0" ? " Branch " : '');
                msg[i++] = (reqReference === "A" && reqAgent === "0" ? " Agent " : '');
                msg[i++] = (reqAgent === "15" && reqAgentLocation === "0" ? " Agent Location" : '');
                msg[i++] = (reqIsd === "0" ? " Currency " : '');
                msg[i++] = (reqQuantity === "" ? " Quantity " : '');
                msg[i++] = ((reqBankCode === "0" && rdBank === "Y") ? " Issuer. " : '');
                isOk = false;
                $('.loader').hide();
                setMsgText(Common.buildMessageFromArray(msg));
                setMsgBox(true);
            }
        }
        if (isOk) {
            var object1 = {
                scrMode: scrMode,
                srno: srNo,
                reqBranch: reqBranchCode,
                reqReference: reqReference,
                reqAgent: reqAgent,
                reqRemitterName: reqRemitterName,
                reqProduct: reqProduct,
                reqProductType: reqProductType,
                reqIsd: reqIsd,
                reqBenCountry: reqBenCountry,
                reqQuantity: reqQuantity,
                reqSellRate: (reqSellRate === "" ? 0 : reqSellRate),
                reqValDate: Common.dateYMD(reqValDate),
                reqPan: reqPan,
                reqNameOnPan: reqNameOnPan,
                reqTenure: reqTenure,
                reqNostroType: reqNostroType,
                rdBank: rdBank,
                reqMobile: reqMobile,
                reqEmail: reqEmail,
                reqRemark: reqRemark,
                reqAgentLocation: reqAgentLocation,
                reqRemitterDob: Common.dateYMD(reqRemitterDob),
                reqCommission: reqCommission,
                showpicklist: Common.showPickList,
                reqGst: reqGst,
                reqTcs: reqTcs,
                reqBankCode: reqBankCode,
                reqRoundoff: reqRoundoff || 0,
                reqTaxableVal: setreqTaxableVal,
                reqBankCharges: reqBankCharges,
                reqRemitterType: reqRemitterType,
                reqTotalForex: totalForex,
                reqTotalInr: totalInr,
                reqIndividual: individual,
                reqIndividualId: individualId,
                reqGroup: corpGroup,
                reqAccount: corpAccount,
                reqNostro: reqNostro,
                reqPurpose: reqPurpose,
                reqAdhar: reqAdhar
            };

            Common.callApi(Common.apiAd1, [sid, 'save', JSON.stringify(object1)], function (result) {
                let resp = JSON.parse(result);
                $('.loader').hide();
                if (resp.status) {
                    resetForm();
                    setScrMode('');
                    setTranListData(resp.list);
                }
                setMsgText(resp.msg);
                setMsgBox(true);
            });
        }
    }

    function getList() {
        setTranListData([]);
        var object1 = {
            reqFrom: Common.dateYMD(reqFrom),
            reqTo: Common.dateYMD(reqTo),
            reqSearch: srchRef,
            searchstatus: searchstatus
        }
        Common.callApi(Common.apiAd1, [sid, 'list', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.length === 0) {
                setMsgText("No enquiry found.");
                setMsgBox(true);
            } else {
                setTranListData(resp);
                setRefreshCounter(refreshCounter + 1);
                if (searchstatus === 'AQC') {
                    setShowFinalCoverForm(true);
                } else {
                    setShowFinalCoverForm(false);
                }
            }
        });
    }

    function handleView(srno) {
        console.log("srno", srno);
        setScrMode('V');
        setSrNo(srno);
        var object1 = {
            srno: srno
        }
        Common.callApi(Common.apiAd1, [sid, 'view', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            console.log(resp);
            $('.loader').hide();
            setViewObj(resp[0]);
            setReqData(resp[0]);
        });
    }

    function handleEdit(srno) {
        setScrMode('E');
        setSrNo(srno);
        var object1 = {
            srno: srno
        }
        Common.callApi(Common.apiAd1, [sid, 'edit', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            console.log(resp);
            $('.loader').hide();
            setEditObj(resp[0]);
            setReqValDate(new Date(Common.dateDMYStr(resp[0].trad_valuedate)));
            setReqReference(resp[0].trad_type);
            setReqAgent(resp[0].agent_name);
            setReqAgentLocation(resp[0].mel_location || 0);
            setReqBranchCode(resp[0].trad_branch);
            setReqBranchName(resp[0].entity_name);
            setreqBankCode(resp[0].trad_bank_code);
            setReqRemitterName(resp[0].trad_remitter_name);
            setReqMobile(resp[0].trad_remitter_contactno);
            setReqEmail(resp[0].trad_email);
            setReqPan(resp[0].trad_remitter_pancard_number);
            setReqNameOnPan(resp[0].trad_nameonpan);
            setReqRemitterDob(new Date(resp[0].trad_remitterdob));
            setReqQuantity(resp[0].trad_quantity);
            setReqSellRate(resp[0].trad_sale_rate);
            setIbr(resp[0].trad_bank_IBR);
            setreqCommission(resp[0].trad_commission);
            setReqIsd(resp[0].trad_currency_name);
            setReqNostroType(resp[0].trad_nostrotype);
            setreqGst(resp[0].trad_gst);
            setreqTcs(resp[0].trad_tcs);
            setreqBankCharges(resp[0].trad_charges);
            setreqNostro(resp[0].trad_nostrocharges);
            setreqRoundoff(resp[0].trad_roundoff);
            setIndividual(resp[0].trad_individual);
            setIndividualId(resp[0].trad_individual_id);
            setCorpAccount(resp[0].trad_account);
            setCorpAccount(resp[0].trad_group);
            setReqRemitterType(resp[0].trad_remmiter_type);
            setReqIssuer(resp[0].issuer_name);
            setReqPurpose(resp[0].trad_purpose || 0);
            if (resp[0].trad_remmiter_type === 'C') {
                (async function () {
                    const res = await Common.getLedgerByGroupAccount('AD1', resp[0].trad_group, resp[0].trad_account)
                    console.log(res);
                    setPickedCorporate(res);
                })()
            } else {
                (async function () {
                    const res = await Common.getIndividualBySrnoID('AD1', resp[0].trad_individual, resp[0].trad_individual_id)
                    console.log(res);
                    setPickedIndividual(res);
                })()
            }
            setReqRemark(resp[0].trad_rmk);
        });
    }

    function addNew() {
        setSrNo(0);
        setAddEditFormShow(true);
        setShowAddNewBtn(false);
        setScrMode("A");
        resetForm();
    }

    function BackForm() {
        setScrMode("");
    }

    function quickCoverFinal(srno) {
        $('.loader').show();
        // console.log("DealBankId", $('#DealBankId' + srno).val());
        // console.log("dealid", $('#DealId' + srno).val());
        // console.log("daelrate", $('#DealRate' + srno).val());
        // console.log("dealvalue", $('#DealValue' + srno).val());
        // console.log("formattedDate", d);
        const dealRateValue = $('#DealRate' + srno).val();
        if (parseFloat(dealRateValue) !== (dealRateValue * 1)) {
            $('.loader').hide();
            setMsgText("Please input valid Deal Rate.");
            setMsgBox(true);
        } else if ($('#DealId' + srno).val() === "") {
            $('.loader').hide();
            setMsgText("Please input valid Deal number.");
            setMsgBox(true);
        } else {
            var dateValue = $('#DealValue' + srno).val();
            var d = dateValue ? new Date(dateValue.split('/').reverse().join('-')) : null;
            var obj = {
                srno: srno,
                valDate: d,
                tenure: $('#DealTenure' + srno).val(),
                bankId: $('#DealBankId' + srno).val(),
                dealId: $('#DealId' + srno).val(),
                dealRate: $('#DealRate' + srno).val(),
                cvalue: $('#DealQty' + srno).val(),
            }

            Common.callApi(Common.apiAd1, [sid, 'quickcoverfinal', JSON.stringify(obj)], function (result) {
                let resp = JSON.parse(result);
                $('.loader').hide();
                if (resp.err === "") {
                    setRefreshCounter(refreshCounter + 1);
                    setMsgText(resp.msg);
                    getList();
                } else {
                    setMsgText(resp.err);
                }
                setMsgBox(true);
            });
        }
    }

    function updateform() {
        $('.loader').show();
        var object1 = {
            srno: srNo,
            reqBranch: reqBranchCode,
            reqReference: reqReference,
            ibr: ibr,
            reqAgent: reqAgent,
            reqRemitterName: reqRemitterName,
            reqProduct: reqProduct,
            reqProductType: reqProductType,
            reqIsd: reqIsd,
            reqBenCountry: reqBenCountry,
            reqQuantity: reqQuantity,
            reqSellRate: (reqSellRate === "" ? 0 : reqSellRate),
            reqValDate: Common.dateYMD(reqValDate),
            reqPan: reqPan,
            reqNameOnPan: reqNameOnPan,
            reqNostroType: reqNostroType,
            rdBank: rdBank,
            reqMobile: reqMobile,
            reqEmail: reqEmail,
            reqRemark: reqRemark,
            reqAgentLocation: reqAgentLocation,
            reqRemitterDob: Common.dateYMD(reqRemitterDob),
            reqCommission: reqCommission,
            showpicklist: Common.showPickList,
            reqGst: reqGst,
            reqTcs: reqTcs,
            reqBankCode: reqBankCode,
            reqRoundoff: reqRoundoff,
            reqTaxableVal: reqTaxableVal,
            reqBankCharges: reqBankCharges,
            reqGroup: corpGroup,
            reqAccount: corpAccount,
            reqRemitterType: reqRemitterType,
            reqIndividual: individual,
            reqIndividualId: individualId,
            reqTotalForex: totalForex,
            reqTotalInr: totalInr,
            reqNostro: reqNostro,
            reqPurpose: reqPurpose
        };
        Common.callApi(Common.apiAd1, [sid, 'update', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            $('.loader').hide();
            if (resp.status) {
                setScrMode('');
                resetForm();
            }
            setMsgText(resp.msg);
            setMsgBox(true);
        });
    }

    function showFilterWindow() {
        setScrMode('');
        setShowCvr(false);
    }

    function showCoverWindow(srno) {
        setScrMode('ADCR');
        setShowCvr(true);
        setSrNo(srno);
    }
    const handleRemitterTypeChange = (v) => {
        setReqRemitterType(v);
        setPickedCorporate(null);
        setPickedIndividual(null);
        setReqRemitterName('');
        // calculateCharges(v, 'I');
    }
    // function isDisableBankDetails() {
    //     if (rightInwardList.edit === "0") {
    //         return true;
    //     } else {
    //         return reqStatus !== "PBC" && ((newBranchProcess === false && editBankDetailsAndRate === false) || (reqBankDetailsConfirm === "1" && newBranchProcess));
    //     }
    // }
    const newIndividual = (btnype) => {
        setShowIndividualForm(true);
        if (btnype === "E" && pickedIndividual != null) setScrIndividual("E");
        else setScrIndividual("A");
    }
    const handleIndividualValue = (value) => {
        setPickedIndividual(value);
        var val = value.id.split("^");
        setIndividual(val[1]);
        setIndividualId(val[2]);
        setReqRemitterName(val[3]);
        setReqPan(val[4]);
        setReqNameOnPan(val[3]);
    }
    const handleCorporateValue = (value) => {
        setPickedCorporate(value);
        var val = value.id.split("^");
        setReqRemitterName(val[10]);
        setCorpGroup(val[1]);
        setCorpAccount(val[2]);
        // calculateCharges(value, 'C');
    }
    // function calculateCharges(v, src) {
    //     //src = C : Corporate
    //     //src = S : Sellrate
    //     //src = B : othercharges
    //     if (!Common.showPickList) return;
    //     const obj = {
    //         reqSellRate: src === "S" ? (v === "" ? 0 : v) : reqClientRate,
    //         reqQuantity: reqQuantity,
    //         reqPurpose: '',
    //         loan: "",
    //         reqPan: "",
    //         reqRemitterType: src === 'I' ? v : reqRemitterType,
    //         pickedCorporate: src === "C" ? v : pickedCorporate,
    //         reqBranch: reqBran,
    //         reqBankChargesInr: src === "B" ? (v === "" ? 0 : v) : (reqClientOthCharges === "" ? 0 : reqClientOthCharges * 1),
    //         reqNostroChargesInr: 0
    //     }
    //     Common.callApi(Common.apiInProgress, [sid, "getcharges", JSON.stringify(obj)], result => {
    //         let resp = JSON.parse(result);
    //         setReqIgstInr(resp.igst);
    //         setReqCgstInr(resp.sgst);
    //         setReqSgstInr(resp.sgst);
    //         setReqUgstInr(resp.ugst);
    //         //setReqTCSInr(resp.tcs);
    //         setReqClientGst(resp.igst * 1 + resp.sgst * 1 + resp.cgst * 1 + resp.ugst * 1);
    //         setReqGstInr(resp.igst + resp.sgst + resp.cgst + resp.ugst);

    //         // setForexAmount(resp.forex);
    //         setReqClientRefundInr(resp.totalinrPP);
    //         setReqRoundOff(resp.roundoffPP);
    //     });
    // }
    // const totalForexHandler = (sellRate, quantity) => {
    //     // (reqSellRate * reqQuantity).toFixed(2)
    //     if (sellRate && quantity){
    //         setForexTotal((sellRate * quantity).toFixed(2));
    //     }else{
    //         setForexTotal(0);
    //     }
    // }

    function totalForexHanlder() {
        setTotalForex((reqSellRate * reqQuantity).toFixed(2));
    }
    function totalInrHanlder() {
        setTotalInr(((reqSellRate * reqQuantity) + (reqTcs * 1) + (reqGst * 1) + (reqCommission * 1) + (reqBankCharges * 1) +
            (reqNostro * 1) + (reqRoundoff * 1)).toFixed(2))
    }
    function showAddMoreDtl(srno) {
        setScrMode('ADDTL');
        setShowAdDtl(true);
        setSrNo(srno);
    }
    function showFinalDocumentUpload(srno) {
        setScrMode('DOCUPLOAD');
        setShowFinalDocUpload(true);
        setSrNo(srno);
    }
    function showFinalDocumentDownload(srno) {
        setScrMode('DOCDOWNLOAD');
        setShowFinalDocUpload(true);
        setSrNo(srno);
    }

    return (
        <>
            <Loginheader />
            <Menu />
            <Container fluid>
                <>
                    {!showCvr && !showAdDtl && !showFinalDocUpload &&
                        <Row>
                            <Col>
                                <h1>Ad1</h1>
                            </Col>
                        </Row>
                    }
                    <Row>
                        {scrMode === "" &&
                            <>
                                <Row>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Status</Form.Label>
                                            <Form.Select value={searchstatus} onChange={e => setSearchStatus(e.target.value)}>
                                                <option value="A">All</option>
                                                <option value="AQC">ADD QUICK COVER</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    {
                                        searchstatus === "A" ?
                                            <>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>From Date</Form.Label>
                                                        <DatePicker className="form-control"
                                                            selected={reqFrom}
                                                            onChange={(date) => setReqFrom(date)}
                                                            isClearable
                                                            dateFormat="dd/MM/yyyy"
                                                            showYearDropdown
                                                            showMonthDropdown
                                                            useShortMonthInDropdown
                                                            dropdownMode="select"
                                                            peekNextMonth
                                                            customInput={
                                                                <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                                            }
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label>To Date</Form.Label>
                                                        <DatePicker className="form-control"
                                                            selected={reqTo}
                                                            onChange={(date) => setReqTo(date)}
                                                            isClearable
                                                            dateFormat="dd/MM/yyyy"
                                                            showYearDropdown
                                                            showMonthDropdown
                                                            useShortMonthInDropdown
                                                            dropdownMode="select"
                                                            peekNextMonth
                                                            customInput={
                                                                <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                                            }
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </> : <>
                                                <Col>&nbsp;</Col>
                                                <Col>&nbsp;</Col>
                                                <Col>&nbsp;</Col>
                                            </>
                                    }
                                </Row>
                                <Row><Col>&nbsp;</Col></Row>
                                <Row><Col>&nbsp;</Col></Row>
                                <Row>
                                    <Col xs={12}>
                                        <Button id="btnSearchRequest" variant="outline-primary" size="sm" onClick={() => getList()}>List</Button>&nbsp;
                                        <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => addNew()}>Add New</Button>
                                    </Col>
                                </Row>
                                <Row><Col>&nbsp;</Col></Row>
                                <Row><Col>&nbsp;</Col></Row>
                                {tranListData.length > 0 ? (
                                    <Row>
                                        <Col>
                                            <Table striped bordered hover>
                                                <thead>
                                                    <tr>
                                                        <td>Action</td>
                                                        <td>Refno</td>
                                                        <td>Date</td>
                                                        <td>Agent</td>
                                                        <td>Branch</td>
                                                        <td>Name</td>
                                                        <td>Currency</td>
                                                        <td>Quantity</td>
                                                        <td>Issuer Bank</td>
                                                    </tr>
                                                </thead>
                                                <tbody id="searchList">
                                                    {tranListData?.map((res) => (
                                                        <React.Fragment key={res.trad_srno}>
                                                            <tr>
                                                                <td>
                                                                    {userRight.query === "1" &&
                                                                        <span className="handCursor colorThemeBlue"
                                                                            title="View Details"
                                                                            onClick={() => handleView(res.trad_srno)}
                                                                        >
                                                                            <FontAwesomeIcon icon={faEye} />&nbsp;&nbsp;
                                                                        </span>
                                                                    }
                                                                    {userRight.edit === "1" && res.trad_status == 1 &&
                                                                        <span className="handCursor colorThemeBlue"
                                                                            title="Edit Details"
                                                                            onClick={() => handleEdit(res.trad_srno)}
                                                                        >
                                                                            <FontAwesomeIcon icon={faEdit} />
                                                                        </span>
                                                                    }&nbsp;&nbsp;
                                                                    {coverRight.query === "1" && res.trad_status == 1 &&
                                                                        <span className={res.trad_coverfinal == 0 ? "colorThemeRed" : "colorThemeBlue"}
                                                                            title="Add Cover"
                                                                            onClick={(e) => showCoverWindow(res.trad_srno)}
                                                                        >
                                                                            <span className="handCursor">
                                                                                <FontAwesomeIcon icon={faRupeeSign} />
                                                                            </span>&nbsp;&nbsp;
                                                                        </span>
                                                                    }
                                                                    {addiDetailRight.query === "1" && res.trad_status == 1 &&
                                                                        <span
                                                                            className={(res.trad_additional_detail_final == "0") ? "colorThemeRed" : "colorThemeBlue"}
                                                                            title="Add Details" onClick={(e) => showAddMoreDtl(res.trad_srno)}
                                                                        >
                                                                            <span className="handCursor" >
                                                                                <FontAwesomeIcon icon={faShareSquare} />
                                                                            </span>&nbsp;
                                                                        </span>
                                                                    }
                                                                    {   // && res.req_bankfilegenrated === "1"
                                                                        // ((rightSwiftUpload.query === "1" || rightInvoiceUpload.query === "1") && res.req_status === "1") &&
                                                                        finalDocUploadRight.query === "1" && res.trad_status == 1 &&
                                                                        <span className={(res.trad_documentsfinal === "1") ? "colorThemeBlue" : ((res.trad_swiftuploaded === "1" && res.trad_invoiceuploaded === "0") ? " " : "colorThemeRed")}
                                                                            title="Upload Final Documents"
                                                                            onClick={(e) => showFinalDocumentUpload(res.trad_srno)}
                                                                        >
                                                                            <span className="handCursor" >
                                                                                <FontAwesomeIcon icon={faCloudUploadAlt} />
                                                                            </span>&nbsp;
                                                                        </span>
                                                                    }
                                                                    {
                                                                        (finalDocDownRight.query === "1" && res.trad_status === "1") && res.trad_status == 1 && res.trad_documentsfinal === "1" &&
                                                                        <span className={"colorThemeBlue"} title="Download Final Documents"
                                                                            onClick={(e) => showFinalDocumentDownload(res.trad_srno)}>
                                                                            <span className="handCursor" ><FontAwesomeIcon icon={faCloudDownloadAlt} /></span>&nbsp;</span>
                                                                    }
                                                                </td>
                                                                <td className={res.trad_status == 0 ? 'bg-danger text-white' : 'bg-info text-white'}>{res.trad_refno || ""}</td>
                                                                <td>{res.trad_valuedate ? res.trad_valuedate.split(' ')[0] : "N/A"}</td>
                                                                <td>
                                                                    {res.trad_agentno * 1 > 0 ? (
                                                                        ` ${res.agent_name || "N/A"} ${res.mel_location || ""}`
                                                                    ) : (
                                                                        "N/A"
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    {res.trad_branch * 1 > 0 ? (
                                                                        ` ${res.entity_name || "N/A"}`
                                                                    ) : (
                                                                        "N/A"
                                                                    )}
                                                                </td>
                                                                <td>{res.trad_remitter_name || "N/A"}</td>
                                                                <td>{res.trad_currency_name || "N/A"}</td>
                                                                <td>{res.trad_quantity || "0"}</td>
                                                                {/* <td>{res.trad_bank_code || "N/A"}</td> */}
                                                                <td>
                                                                    {res.trad_bank_code * 1 > 0 ? (
                                                                        ` ${res.issuer_name || "N/A"}`
                                                                    ) : (
                                                                        "N/A"
                                                                    )}
                                                                </td>
                                                            </tr>
                                                            {/* {searchstatus === 'AQC' && res.trad_coverfinal == 0 ? */}
                                                            {showFinalCoverForm && res.trad_coverfinal == 0 ?
                                                                <tr>
                                                                    <td colSpan={7} style={{ textAlign: "center", background: "#f9f9f9", padding: '10px' }}>
                                                                        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', alignItems: 'center' }}>
                                                                            <Form.Group>
                                                                                <Form.Select
                                                                                    id={"DealTenure" + res.trad_srno}
                                                                                    value={reqTenure}
                                                                                    onChange={(e) => setReqTenure(e.target.value)}
                                                                                    style={{ width: '150px' }}
                                                                                >
                                                                                    <option value="TOM">TOM</option>
                                                                                    <option value="CASH">CASH</option>
                                                                                    <option value="SPOT">SPOT</option>
                                                                                </Form.Select>
                                                                            </Form.Group>
                                                                            <Form.Group>
                                                                                <DatePicker
                                                                                    className="form-control"
                                                                                    id={"DealValue" + res.trad_srno}
                                                                                    selected={reqValDate || null}
                                                                                    onChange={(date) => setReqValDate(date)}
                                                                                    isClearable
                                                                                    dateFormat="dd/MM/yyyy"
                                                                                    showYearDropdown
                                                                                    showMonthDropdown
                                                                                    useShortMonthInDropdown
                                                                                    dropdownMode="select"
                                                                                    peekNextMonth
                                                                                    customInput={<input
                                                                                        type="text"
                                                                                        onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}
                                                                                        style={{ width: '150px' }}
                                                                                    />}
                                                                                />
                                                                            </Form.Group>
                                                                            <input type="hidden" id={"DealBankId" + res.trad_srno} value={res.trad_bank_code} />
                                                                            <input type="hidden" id={"DealQty" + res.trad_srno} value={res.trad_quantity} />
                                                                            <input
                                                                                type="text"
                                                                                className="QuickDeal"
                                                                                id={"DealId" + res.trad_srno}
                                                                                placeholder="Deal ID"
                                                                                style={{ width: '150px' }}
                                                                            />
                                                                            <input
                                                                                type="text"
                                                                                className="QuickDeal"
                                                                                id={"DealRate" + res.trad_srno}
                                                                                placeholder="Deal Rate"
                                                                                maxLength={20}
                                                                                autoComplete="off"
                                                                                style={{ width: '150px' }}
                                                                            />
                                                                            <Button
                                                                                onClick={() => quickCoverFinal(res.trad_srno)}
                                                                                style={{ width: '150px' }}
                                                                            >
                                                                                Final Cover
                                                                            </Button>
                                                                        </div>
                                                                    </td>

                                                                </tr> : null
                                                            }
                                                        </React.Fragment>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                ) : null}

                            </>
                        }
                        {(scrMode === "A" || scrMode === "E") &&
                            <>
                                {scrMode === "E" && <>
                                    <Row>
                                        <Col><h5>Sr. No :</h5> {editObj?.trad_srno} </Col>
                                        <Col><h5>Agent Name :</h5> {editObj?.agent_name}</Col>
                                        <Col><h5>Branch :</h5> {editObj?.entity_name}</Col>
                                    </Row>
                                    <Row><Col>&nbsp;</Col></Row>
                                    <Row>
                                        {/* <Col><h5>Branch :</h5> {editObj?.entity_name}</Col> */}
                                        <Col><h5>Quantity: </h5>{editObj?.trad_quantity}</Col>
                                        <Col><h5>Currency Name :</h5> {editObj?.trad_currency_name}</Col>
                                    </Row>
                                    <Row><Col>&nbsp;</Col></Row>
                                    <Row><Col>&nbsp;</Col></Row>
                                </>}
                                <Row>
                                    <Col className='col-md-4'>
                                        <Form.Group >
                                            <Form.Label>Transaction date<span className="mandatory">*</span></Form.Label>
                                            <DatePicker className="form-control"
                                                selected={reqValDate}
                                                onChange={(date) => setReqValDate(date)}
                                                isClearable
                                                dateFormat="dd/MM/yyyy"
                                                showYearDropdown
                                                showMonthDropdown
                                                useShortMonthInDropdown
                                                dropdownMode="select"
                                                peekNextMonth
                                                customInput={
                                                    <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                                }
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col className='col-md-4'>
                                        <Form.Group >
                                            <Form.Label>Reference<span className="mandatory">*</span></Form.Label>
                                            <Form.Select
                                                value={reqReference}
                                                onChange={(e) => onChangeRefrence(e.target.value)}
                                                disabled={entityType === 'A'} >
                                                <option value="S">Self</option>
                                                <option value="A">Agent</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label>
                                                Branch<span className="mandatory">*</span>
                                            </Form.Label>
                                            <Form.Select
                                                value={reqBranchCode}
                                                onChange={(e) => onChangeBranch(e.target.value)}
                                                disabled={
                                                    entityType === "A" || ddReqBranchOptions.length === 2
                                                }
                                            >
                                                {ddReqBranchOptions.map((res) => (
                                                    <option key={res.value} value={res.value}>
                                                        {res.name}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label>Issuer </Form.Label>
                                            <Form.Select
                                                value={rdBank}
                                                onChange={(e) => setRdBank(e.target.value)}
                                                disabled={true}
                                            >
                                                <option value="Y">Yes</option>
                                                <option value="N">No</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    {rdBank === "Y" && (
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label>
                                                    Issuer Name<span className="mandatory">*</span>
                                                </Form.Label>
                                                <Form.Select
                                                    value={reqBankCode}
                                                    onChange={(e) => setreqBankCode(e.target.value)}
                                                >
                                                    {ddReqIssuer.map((res) => (<option key={res.value} value={res.value}>
                                                        {res.name}
                                                    </option>))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    )}
                                    <Col className='col-md-4'>
                                        <Form.Group >
                                            <Form.Label>Purpose {entityType === "A" ? <span className="mandatory">*</span> : null} </Form.Label>
                                            <Form.Select
                                                value={reqPurpose}
                                                onChange={(e) => setReqPurpose(e.target.value)}  >
                                                <input type="text" />
                                                {ddReqPurposeOptions.map((res) =>
                                                    <option key={res.value} value={res.value}>{res.name}</option>
                                                )}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                {
                                    Common.showPickList &&
                                    <>
                                        <Row>
                                            <Col className='col-md-4'>
                                                <Form.Group>
                                                    <Form.Label>Client Type</Form.Label>
                                                    <Form.Select
                                                        value={reqRemitterType}
                                                        onChange={(e) => handleRemitterTypeChange(e.target.value)}
                                                    // disabled={isDisableBankDetails()}
                                                    >
                                                        <option value="I">Individual</option>
                                                        <option value="C">Corporate</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            {
                                                (reqRemitterType === "I") ?
                                                    <Col className='col-md-8'>
                                                        <Form.Group>
                                                            <Form.Label>Individual<span className='coloThemeRed'>*</span>
                                                                <span className='tranNewFormText' onClick={() => newIndividual("A")}>Not in list? Create New</span>
                                                                &nbsp;&nbsp;
                                                                <span className='tranNewFormText' onClick={() => newIndividual("E")}>Edit</span>
                                                            </Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={pickedIndividual}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={Picklist.fetchIndividualProfilePicklist} // location = 1 , 2
                                                                onInputChange={Picklist.handleInputChange}
                                                                formatOptionLabel={Picklist.formatOptionLabel}
                                                                components={{ Menu: Picklist.menu }}
                                                                onChange={handleIndividualValue}
                                                            // isDisabled={isDisableBankDetails()}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                    : ((reqRemitterType === "C") &&
                                                        <Col className='col-md-9'>
                                                            <Form.Group>
                                                                <Form.Label>Ledger<span className='coloThemeRed'>*</span></Form.Label>
                                                                <AsyncSelect
                                                                    cacheOptions={false}
                                                                    defaultOptions={false}
                                                                    value={pickedCorporate}
                                                                    getOptionLabel={e => e.label + ' '}
                                                                    getOptionValue={e => e.id}
                                                                    loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, "CORPORATE, DEALER", reqBranchCode)} // location = 1 , 2
                                                                    onInputChange={Picklist.handleInputChange}
                                                                    onChange={handleCorporateValue}
                                                                // isDisabled={isDisableBankDetails()}
                                                                >
                                                                </AsyncSelect>
                                                            </Form.Group>
                                                        </Col>)
                                            }
                                        </Row>
                                    </>
                                }
                                <Row>
                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label>
                                                Remitter Name <span className="mandatory">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Remitter Name"
                                                maxLength={50}
                                                autoComplete="off"
                                                value={reqRemitterName}
                                                onChange={(e) =>
                                                    Common.validateAlpNumPAN(e.target.value, setReqRemitterName)
                                                }
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label>
                                                Remitter Pancard Number<span className="mandatory">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Pancard Number"
                                                maxLength={10}
                                                autoComplete="off"
                                                value={reqPan}
                                                onChange={(e) => setReqPan(e.target.value)}
                                                onBlur={(e) => Common.validatePan(e.target.value, setReqPan)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group >
                                            <Form.Label>Name On PAN</Form.Label>
                                            <Form.Control type="text" placeholder="Name on PAN" maxLength={50} autoComplete="off"
                                                value={reqNameOnPan}
                                                onChange={(e) => Common.validateAlpNumPAN(e.target.value, setReqNameOnPan)}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label>
                                                Aadhar Number
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Remitter Aadhar Number"
                                                maxLength={16}
                                                autoComplete="off"
                                                value={reqAdhar}
                                                onChange={(e) =>
                                                    Common.validateNumValue(e.target.value, setReqAdhar)
                                                }
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label>
                                                Remitter Contact No<span className="mandatory">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Remitter Contact No"
                                                maxLength={10}
                                                autoComplete="off"
                                                value={reqMobile}
                                                onChange={(e) =>
                                                    Common.validateNumValue(e.target.value, setReqMobile)
                                                }
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group >
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control type="email" placeholder="Email" maxLength={100} autoComplete="off"
                                                value={reqEmail}
                                                onChange={(e) => setReqEmail(e.target.value)}
                                                onBlur={(e) => Common.validtateEmail(e.target.value, setReqEmail)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group >
                                            <Form.Label>Date of Birth<span className="mandatory">*</span></Form.Label>
                                            <DatePicker className="form-control"
                                                selected={reqRemitterDob}
                                                onChange={(date) => setReqRemitterDob(date)}
                                                isClearable={false}
                                                dateFormat="dd/MM/yyyy"
                                                showYearDropdown
                                                showMonthDropdown
                                                useShortMonthInDropdown
                                                dropdownMode="select"
                                                peekNextMonth

                                                customInput={
                                                    <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                                }
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>

                                </Row>

                                <Row>
                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label>
                                                Currency Name<span className="mandatory">*</span>
                                            </Form.Label>
                                            <Form.Select
                                                value={reqIsd}
                                                onChange={(e) => setReqIsd(e.target.value)}
                                            >
                                                {ddReqIsdOptions.map((res) => (
                                                    <option key={res.value} value={res.value}>
                                                        {res.name}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group >
                                            <Form.Label>Quantity<span className="mandatory">*</span></Form.Label>
                                            <Form.Control type="text" placeholder="Quantity" maxLength={10}
                                                onChange={(e) => Common.validateDecValue(e.target.value, setReqQuantity)}
                                                value={reqQuantity} autoComplete="off" />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label>Sale Rate</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Sale Rate"
                                                maxLength={10}
                                                autoComplete="off"
                                                value={reqSellRate}
                                                onChange={(e) =>
                                                    Common.validateDecValue(e.target.value, setReqSellRate)
                                                }
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label>Bank IBR</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Bank IBR"
                                                maxLength={10}
                                                value={ibr}
                                                onChange={(e) =>
                                                    Common.validateDecValue(e.target.value, setIbr)
                                                }
                                                autoComplete="off"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label>GST </Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Gst"
                                                maxLength={15}
                                                value={reqGst}
                                                autoComplete="off"
                                                onChange={(e) => setreqGst(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label>TCS </Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Tcs"
                                                maxLength={15}
                                                value={reqTcs}
                                                autoComplete="off"
                                                onChange={(e) => setreqTcs(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label>Bank Charges </Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="BankCharges"
                                                maxLength={15}
                                                value={reqBankCharges}
                                                autoComplete="off"
                                                onChange={(e) => setreqBankCharges(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group >
                                            <Form.Label>Nostro Charges{entityType === "A" ? <span className="mandatory">*</span> : null}</Form.Label>
                                            <Form.Select
                                                value={reqNostroType}
                                                onChange={(e) => setReqNostroType(e.target.value)} >
                                                <option value="0" >Select</option>
                                                <option value="OUR">OUR</option>
                                                <option value="BEN">BEN</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label>Nostro </Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Nostro"
                                                maxLength={15}
                                                value={reqNostro}
                                                autoComplete="off"
                                                onChange={(e) => setreqNostro(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label>Round off </Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Roundoff"
                                                maxLength={15}
                                                value={reqRoundoff}
                                                autoComplete="off"
                                                onChange={(e) => setreqRoundoff(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row><Col>&nbsp;</Col></Row>
                                <Col>
                                    Forex : {totalForex}&nbsp;&nbsp;&nbsp;
                                    Total: <b>{totalInr}
                                    </b>
                                </Col>
                                <hr />
                                <Row>
                                    {reqReference === "A" &&
                                        <>
                                            <Col className='col-md-4'>
                                                <Form.Group>
                                                    <Form.Label>Agent Name<span className="mandatory">*</span></Form.Label>
                                                    <Form.Select
                                                        value={reqAgent}
                                                        onChange={(e) => onChangeAgent(e.target.value)}
                                                        disabled={entityType === 'A'} >
                                                        {ddReqAgentOptions.map((res) =>
                                                            <option key={res.value} value={res.value}>{res.name}</option>
                                                        )}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            {
                                                reqAgent * 1 > 0 && <>
                                                    <Col className='col-md-4'>
                                                        <Form.Group>
                                                            <Form.Label>Agent Location</Form.Label>
                                                            <Form.Select
                                                                value={reqAgentLocation}
                                                                onChange={(e) => setReqAgentLocation(e.target.value)}
                                                                disabled={entityType === 'A'} >
                                                                {ddReqAgentLocationOptions.map((res) =>
                                                                    <option key={res.value} value={res.value}>{res.name}</option>
                                                                )}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                </>
                                            }

                                        </>

                                    }
                                    {/* <Row> */}
                                    <Col md={4}>
                                        <Form.Group>
                                            <Form.Label>Commission {entityType === "A" ? <span className="mandatory">*</span> : null}</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Commission"
                                                maxLength={10}
                                                autoComplete="off"
                                                value={reqCommission}
                                                onChange={(e) => setreqCommission(e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                {/* </Row> */}
                                <Row><Col>&nbsp;</Col></Row>
                                <Row>
                                    <Col>
                                        <Form.Group controlId="txtRequestRemark">
                                            <Form.Label>Request Remark</Form.Label>
                                            <Form.Control as="textarea" rows={1} placeholder="Request Remark" maxLength={99} autoComplete="off"
                                                value={reqRemark}
                                                onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqRemark)}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row><Col>&nbsp;</Col></Row>
                                <Row>
                                    <Col>
                                        {scrMode === "A" &&
                                            <Button variant="outline-success" size="sm" onClick={(e) => saveData()} >Submit </Button>
                                        }&nbsp;
                                        <Button variant="outline-danger" size="sm" onClick={(e) => resetForm()} >Reset </Button>
                                        &nbsp;
                                        <Button variant="outline-danger" size="sm" onClick={(e) => BackForm()} >Back </Button>
                                        &nbsp;
                                        {scrMode === "E" &&
                                            <Button variant="outline-success" size="sm" onClick={(e) => updateform()} >Update </Button>
                                        }
                                    </Col>
                                </Row>
                                <Row><Col>&nbsp;</Col></Row>
                                <Row><Col>&nbsp;</Col></Row>
                            </>
                        }
                        {scrMode === "V" &&
                            // <>
                            //     <Button
                            //         variant="outline-danger" className="btn btn-sm custom-btn"
                            //         style={{ padding: "2px 8px", fontSize: "16px", height: "30px", width: "90px" }}
                            //         onClick={(e) => BackForm()}
                            //     >
                            //         Back
                            //     </Button>
                            //     <Row><Col>&nbsp;</Col></Row>
                            //     <Row>
                            //         <Col><h6>Transaction Date:</h6> {viewObj?.trad_valuedate.substring(0, 8)}</Col>
                            //         <Col><h6>Reference :</h6> {viewObj?.trad_refno} </Col>
                            //         <Col><h6>Agent Name :</h6> {viewObj?.agent_name}</Col>
                            //         <Col><h6>Agent Location :</h6> {viewObj?.mel_location}</Col>
                            //     </Row>
                            //     <Row><Col>&nbsp;</Col></Row>
                            //     <Row>
                            //         <Col><h6>Branch :</h6> {viewObj?.entity_name}</Col>
                            //         {/* <Col><h5>Issuer : </h5></Col> */}
                            //         <Col><h6>Dob : </h6> {viewObj?.trad_remitterdob?.split('-').reverse().join('/')}</Col>
                            //         <Col><h6>Issuer Name:</h6> {viewObj?.issuer_name}</Col>
                            //         <Col><h6>Remitter Name:</h6> {viewObj?.trad_remitter_name}</Col>
                            //     </Row>
                            //     <Row><Col>&nbsp;</Col></Row>
                            //     <Row>
                            //         <Col><h6>Remitter Contact No :</h6> {viewObj?.trad_remitter_contactno}</Col>
                            //         <Col><h6>Remitter Adhar No :</h6> {viewObj?.trad_Adhar}</Col>
                            //         <Col><h6>Email :</h6> {viewObj?.trad_email}</Col>
                            //         <Col><h6>Remitter Pancard Number : </h6>{viewObj?.trad_remitter_pancard_number}</Col>
                            //         <Col><h6>Name On PAN :</h6> {viewObj?.trad_nameonpan}</Col>
                            //     </Row>
                            //     <Row><Col>&nbsp;</Col></Row>
                            //     <Row>
                            //         <Col><h6>Date of Birth:</h6> {viewObj?.trad_remitterdob}</Col>
                            //         <Col><h6>Quantity: </h6>{viewObj?.trad_quantity}</Col>
                            //         <Col><h6>Sale Rate :</h6> {viewObj?.trad_sale_rate}</Col>
                            //         <Col><h6>Bank IBR : </h6>{viewObj?.trad_bank_IBR}</Col>
                            //     </Row>
                            //     <Row><Col>&nbsp;</Col></Row>
                            //     <Row>
                            //         <Col><h6>Commission :</h6> {viewObj?.trad_commission}</Col>
                            //         <Col><h6>Currency Name :</h6> {viewObj?.trad_currency_name}</Col>
                            //         <Col><h6>Nostro Charges : </h6>{viewObj?.trad_nostrotype}</Col>
                            //         <Col><h6>GST :</h6> {viewObj?.trad_gst}</Col>
                            //     </Row>
                            //     <Row><Col>&nbsp;</Col></Row>
                            //     <Row>
                            //         <Col><h6>TCS :</h6>{viewObj?.trad_tcs}</Col>
                            //         <Col><h6>Bank Charges :</h6>{viewObj?.trad_charges}</Col>
                            //         <Col><h6>Nostro :</h6>{viewObj?.trad_nostrocharges}</Col>
                            //         <Col><h6>Round off :</h6>{viewObj?.trad_roundoff}</Col>
                            //     </Row>
                            //     <Row><Col>&nbsp;</Col></Row>
                            //     <Row>
                            //         <Col><h6>Forex Total</h6>{viewObj?.trad_total_forex}</Col>
                            //         <Col><h6>Total Amount</h6>{viewObj?.trad_total_inr}</Col>
                            //     </Row>
                            //     <Row><Col>&nbsp;</Col></Row>
                            //     <Row>
                            //         <Col><h6>Request Remark :</h6>{viewObj?.trad_rmk}</Col>
                            //     </Row>
                            //     <Row><Col>&nbsp;</Col></Row>
                            //     <Button
                            //         variant="outline-danger" className="btn btn-sm custom-btn"
                            //         style={{ padding: "2px 8px", fontSize: "16px", height: "30px", width: "90px" }}
                            //         onClick={(e) => BackForm()}
                            //     >
                            //         Back
                            //     </Button>
                            //     <Row><Col>&nbsp;</Col></Row>
                            // </>
                            <>
                                <Row>
                                    <Col>
                                        <Ad1RequestHeader back={BackForm} rhdata={reqData} viewData={viewObj}></Ad1RequestHeader>
                                    </Col>
                                </Row>
                                <Ad1ActivityLog srno={srNo} />
                            </>
                        }
                    </Row>
                </>
                {/* } */}
                {showCvr && scrMode === 'ADCR' &&
                    <Ad1CoverRate srno={srNo} callAd1={showFilterWindow}></Ad1CoverRate>
                }
                {showAdDtl && scrMode === 'ADDTL' &&
                    <Ad1AdditionalDetails srno={srNo} callAd1={showFilterWindow}></Ad1AdditionalDetails>
                }
                {showFinalDocUpload && scrMode === 'DOCUPLOAD' &&
                    <Ad1FinalDocUpload srno={srNo} callAd1={showFilterWindow}></Ad1FinalDocUpload>
                }
                {showFinalDocUpload && scrMode === 'DOCDOWNLOAD' &&
                    <Ad1FinalDocDownload srno={srNo} callAd1={showFilterWindow}></Ad1FinalDocDownload>
                }
                <Row>
                    <Col>&nbsp;</Col>
                </Row>
            </Container>

            <div>
                <Dialog
                    isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>{msgText}
                </Dialog>
            </div>
            <Modal
                show={showConfirmBox} onHide={() => setShowConfirmBox(false)} centered>
                <Modal.Body>
                    <h3>
                        {
                            reqPan !== "" ?
                                <>
                                    <Row>
                                        <Col>
                                            This : {1 * reqQuantity * reqSellRate}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            Total : {Math.round(((1 * panTCS.forex) + (1 * reqQuantity * reqSellRate)))}
                                        </Col>
                                    </Row>
                                </>
                                : null
                        }

                        <Row>
                            <Col>
                                ISD : {reqIsd}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                Quantity : {reqQuantity}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                Sale Rate :  {reqSellRate}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                Tenure : {reqTenure}
                            </Col>
                        </Row>
                    </h3>
                    <Row className='divHide'>
                        <Col>
                            <b>Bank : {reqIssuer} </b>
                        </Col>
                    </Row>
                    <Row>
                        <Col>&nbsp;</Col>
                    </Row>
                </Modal.Body>
            </Modal>

        </>
    );


}

export default Ad1;
